import * as amplitude from '@amplitude/analytics-browser';
import { AMPLITUDE_PROPERTIES } from '../constants/amplitudeConstants';

export const initAmplitude = () => {
  try {
    amplitude.init(process.env.REACT_APP_AMPLITUDE);
  } catch (error) {
    console.error({
      Error: error,
    });
  }
};

export const sendAmplitudeData = (eventType, eventProperties) => {
  try {
    amplitude.track(eventType, eventProperties);
  } catch (error) {
    console.error({
      Error: error,
    });
  }
};

export const setAmplitudeUserProperties = (properties, value) => {
  try {
    const identifyEvent = new amplitude.Identify();
    identifyEvent.setOnce(properties, value);
    amplitude.identify(identifyEvent);
  } catch (error) {
    console.error({
      Error: error,
    });
  }
};

export const getOrgAmplitudeProperties = (loginDetails) => {
  return {
    [AMPLITUDE_PROPERTIES.ORG_ID]: loginDetails?.fortellisEnterpriseEntityId,
    [AMPLITUDE_PROPERTIES.ORG_NAME]: loginDetails?.entityDetails?.organizationName
  };
};
